import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

import InlineSection from '../InlineSection';

const ExpandableSection = ({ icon = null, mainContent, subContent, theme, className, children }) => {
    const [isExpanded, setExpanded] = useState(false);

    const wrapperClasses = classnames(theme.root, {
        [theme.rootIsCollapsed]: !isExpanded,
        [theme.rootHeaderToggleable]: true,
    });

    const handleIconClick = () => {
        setExpanded(prevExpanded => !prevExpanded);
    };

    return (
        <div className={ classnames({
            [theme.expandableSection]: true,
            [className]: !!className,
            [theme.expanded]: isExpanded,
        }) }
        >
            <InlineSection
                icon={ icon }
                subContent={ subContent }
                mainContent={ (
                    <span className={ theme.expandableSectionHeader }>
                        {mainContent}
                        <span
                            className={ theme.expandIconWrapper }
                            onClick={ handleIconClick }
                            role="button"
                            tabIndex={ 0 }
                        >
                            {isExpanded
                                ? <ExpandLess className={ theme.expandIcon } />
                                : <ExpandMore className={ theme.expandIcon } />}
                        </span>
                    </span>
                ) }
                theme={ theme }
            />
            <section className={ wrapperClasses }>
                { children }
            </section>
        </div>
    );
};

ExpandableSection.propTypes = {
    theme: PropTypes.shape({}),
    icon: PropTypes.shape({
        name: PropTypes.string,
        className: PropTypes.string,
    }),
    mainContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subContent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({}),
    ]),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default ExpandableSection;
